import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import QRCode from "qrcode";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import { Button } from "antd";

const ShareComponent = ({ url, title }) => {
  const qrRef = React.useRef();

  const handleDownloadQR = async () => {
    try {
      // Generar QR específico para descarga con configuración optimizada
      const canvas = document.createElement('canvas');
      
      await QRCode.toCanvas(canvas, url, {
        width: 1000,           // Muy alta resolución
        margin: 4,             // Margen generoso
        color: {
          dark: '#000000',     // Negro puro
          light: '#FFFFFF'     // Blanco puro
        },
        errorCorrectionLevel: 'H',  // Máxima corrección de errores
        type: 'image/png',
        quality: 1.0,          // Máxima calidad
        rendererOpts: {
          quality: 1.0
        }
      });
      
      const imageUrl = canvas.toDataURL("image/png", 1.0);
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "qr-code-inmersial.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error al descargar QR:", error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        {/* Facebook */}
        <FacebookShareButton url={url} quote={title}>
          <FacebookIcon size={40} round />
        </FacebookShareButton>

        {/* Twitter */}
        <TwitterShareButton url={url} title={title}>
          <TwitterIcon size={40} round />
        </TwitterShareButton>

        {/* WhatsApp */}
        <WhatsappShareButton url={url} title={title}>
          <WhatsappIcon size={40} round />
        </WhatsappShareButton>

        {/* LinkedIn */}
        <LinkedinShareButton url={url} title={title}>
          <LinkedinIcon size={40} round />
        </LinkedinShareButton>
      </div>

      <div
        ref={qrRef}
        style={{
          textAlign: "center",
          borderTop: "1px solid #eee",
          paddingTop: "15px",
        }}
      >
        <p style={{ marginBottom: "10px" }}>O escanea este código QR:</p>
        <QRCodeCanvas
          value={url}
          size={400}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
          includeMargin={true}
          style={{
            width: "120px",
            height: "120px",
            imageRendering: "auto",
          }}
        />
        <p style={{ fontSize: "12px", color: "#666", marginTop: "8px" }}>
          Escanea para abrir la experiencia
        </p>
        <Button
          onClick={handleDownloadQR}
          type="primary"
          ghost
        >
          Descargar QR
        </Button>
      </div>
    </div>
  );
};

export default ShareComponent;
